const { jQuery: $ } = window;

import PostFilters from "./classes/PostFilters.class";
import Logger from "./classes/Logger.class";

const plugin = new PostFilters(
    new Logger("KPF", "#f3be06"),
    require("mustache")
);

$("document").ready(() => plugin.ready());